import { useCallback } from 'react';
import { useProjectContext } from '~/modules/resourcing/common/contexts';

const useOnRemoveTaskAllocationSuccess = ({
  onClose,
  handleRemoveResourceAllocation,
  userId
}) => {
  const {
    projectObjectPermissions: { canEditResourceAllocation }
  } = useProjectContext();

  return {
    onRemoveTaskAllocationSuccess: useCallback(
      ({ deleteTaskResourceUserAllocationResult }) => {
        onClose();
        if (
          canEditResourceAllocation &&
          !deleteTaskResourceUserAllocationResult
            ?.deleteTaskResourceUserAllocation?.syncedResourceAllocation
        ) {
          handleRemoveResourceAllocation(userId);
        }
      },
      [
        canEditResourceAllocation,
        handleRemoveResourceAllocation,
        onClose,
        userId
      ]
    )
  };
};

export default useOnRemoveTaskAllocationSuccess;
